import { isTokenAlive } from '@omniflow/browser-bus'

/** Что показывать на экране входа: форму или «Вы вошли как…» (SESSRENEW O12). */
export type LoginMode = 'form' | 'signed-in'

/**
 * Режим экрана входа по токену из стора. «Вошли» только при живом токене:
 * токен есть, но мёртв или без имени пользователя — обычная форма (keeper и модалка перелогина разбираются с ним сами).
 * Пока идёт вход с этой формы (`loginInFlight`), остаётся форма: токен в стор уже записан, но подключение к шине
 * и переход на `/` ещё впереди — иначе на секунду мигает «Вы вошли как… Продолжить / Выйти».
 */
export const resolveLoginMode = (
  token: string | null,
  username: string | null,
  opts: { loginInFlight?: boolean } = {},
): LoginMode =>
  !opts.loginInFlight && token !== null && username !== null && isTokenAlive(token) ? 'signed-in' : 'form'
